import { Injectable } from '@angular/core';
import { TextEditorPopverComponent } from './text-editor-popver/text-editor-popver.component';
import { BorderPresetPopoverComponent } from './border-preset-popover/border-preset-popover.component';
import { FontFamilyPopoverComponent } from './font-family-popover/font-family-popover.component';
import { FontSizePopoverComponent } from './font-size-popover/font-size-popover.component';
import { FontWeightPopoverComponent } from './font-weight-popover/font-weight-popover.component';
import { PaddingPresetPopoverComponent } from './padding-preset-popover/padding-preset-popover.component';
import { SliderPopoverComponent } from './slider-popover/slider-popover.component';
import { VisibilityPopoverComponent } from './visibility-popover/visibility-popover.component';
import { NbMenuBag } from '@nebular/theme';
import { OverlayRef } from '@angular/cdk/overlay';
import { Subscription } from 'rxjs';
import { ColorPickerPopoverComponent } from './color-picker-popover/color-picker-popover.component';
import { LayoutPopoverComponent } from './layout-popover/layout-popover.component';
import { SampleImageDirectoryComponent } from '../sample-image-directory/sample-image-directory.component';
import { CellBgEditorComponent } from '../cell-bg-editor/cell-bg-editor.component';

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
  private currentOverlayRef: OverlayRef | null = null;
  textPop: any = TextEditorPopverComponent;
  colorPop: any = ColorPickerPopoverComponent;
  borderPop:any = BorderPresetPopoverComponent;
  paddingPop:any = PaddingPresetPopoverComponent;
  sliderPop:any = SliderPopoverComponent;
  fontSizePop:any = FontSizePopoverComponent;
  fontFamPop:any = FontFamilyPopoverComponent;
  fontWeight:any = FontWeightPopoverComponent;
  visibilityPop:any = VisibilityPopoverComponent;
  layoutPop:any = LayoutPopoverComponent;
  imageDialog:any = SampleImageDirectoryComponent;
  layerPop:any = CellBgEditorComponent;

  textColor:string;
  bgColors$:Subscription;
  pmColors$:Subscription;
  bgBasic:string[]=[]
  bgPrimary:string[]=[]
  bgAlt:string[]=[]
  fillColors:string[];
  primaryColors:string[]=[];

  headers = [
    {name:"Header 6",value:"h6"},
    {name:"Header 5",value:"h5"},
    {name:"Header 4",value:"h4"},
    {name:"Header 3",value:"h3"},
    {name:"Header 2",value:"h2"},
    {name:"Header 1",value:"h1"},
  ]

  constructor() { }


  // Helper method to get the correct popover component
  getPopoverComponent(popoverType: string): any {
    switch (popoverType) {
      case 'textPopover': return this.textPop;
      case 'fontColor': return this.colorPop;
      case 'fontSize': return this.fontSizePop;
      case 'fontWeight': return this.fontWeight;
      case 'alignLeft': return this.borderPop;
      case 'alignCenter': return this.borderPop;
      case 'alignRight': return this.borderPop;
      case 'margin': return this.borderPop;
      case 'padding': return this.borderPop;
      case 'border': return this.borderPop;
      case 'background': return this.colorPop;
      case 'visibilityPopover':return this.visibilityPop;
      case 'layout':return this.layoutPop;
      case 'imageDialog':return this.imageDialog;
      case 'color':return this.colorPop;
      case 'layer': return this.layerPop;
      default: return null;
    }
  }

  getPopoverContext(popoverData: any) {
    console.log(popoverData);
    return {
      title: popoverData.popoverTitle != undefined ? popoverData.popoverTitle : popoverData.title || "Popover Title",
      headers: this.headers,
      target: popoverData.target,
      property: popoverData.property != undefined ? popoverData.property : undefined,
      service:popoverData.service != undefined ? popoverData.service : undefined,
      color:this.textColor,
      declaration: popoverData.declaration,
      content:popoverData.content != undefined ? popoverData.content : undefined
    };
  }


}
